import React from 'react';
import { CompositeDecorator } from 'draft-js';

// Function to render the image component
const ImageComponent = (props) => {
    const { src, alt } = props.contentState.getEntity(props.entityKey).getData();
    console.log(src, alt);  // Debug log
    return <img src={src} alt={alt} style={{ width: '100%', height: 'auto' }} />;
};


// Custom decorator strategy to find IMAGE entities
const findImageEntities = (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(
        (character) => {
            const entityKey = character.getEntity();
            if (entityKey !== null) {
                const entity = contentState.getEntity(entityKey);
                if (entity && entity.getType() === 'IMAGE') {
                    return true;
                }
            }
            return false;
        },
        callback
    );
};


// Custom decorator for handling images
const imageDecorator = new CompositeDecorator([
    {
        strategy: findImageEntities,
        component: ImageComponent,
    },
]);

export default imageDecorator;
